import { EmailCodeView } from '@marketplace-web/domain/verification'
import { isResponseError } from '@marketplace-web/shared/api-client'
import { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'
import { clickEvent } from '_libs/common/event-tracker/events'
import { EMAIL_CODE_VERIFICATION_URL } from 'constants/routes'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { dismissVerificationPrompt } from 'data/api/dismiss-verification-prompt'
import { Screen } from 'constants/tracking/screens'
import { getVerificationPrompt } from 'data/api/get-verification-prompt'
import { VerificationMethods } from 'constants/verification'

export const fetchCurrentUserVerificationPrompts = async ({ userId }: { userId: number }) => {
  const prompts = await getVerificationPrompt(userId)

  if (isResponseError(prompts)) return null

  return prompts
}

export const handleDismissVerificationPrompt = async ({ userId }: { userId: number }) => {
  const prompts = await fetchCurrentUserVerificationPrompts({ userId })

  if (!prompts) return

  const isEmailCodeMethod = prompts.prompt.methods.includes(VerificationMethods.EmailCode)
  const isMandatory = prompts.prompt.mandatory

  if (!isEmailCodeMethod || isMandatory) return

  await dismissVerificationPrompt(userId)
}

export const trackLogoutEvent = async ({
  relativeUrl,
  view,
  track,
  userId,
}: {
  userId: number
  relativeUrl: string
  view: string
  track: (event: TrackingEvent) => void
}) => {
  const prompts = await fetchCurrentUserVerificationPrompts({ userId })

  const isEmailCodeMethod = prompts?.prompt.methods.includes(VerificationMethods.EmailCode)
  if (!isEmailCodeMethod) return

  const screenByEmailCodeView = {
    [EmailCodeView.EnterCode]: Screen.MandatoryEmailVerificationEnterCode,
    [EmailCodeView.NotReceiveEmail]: Screen.MandatoryEmailVerificationResendCode,
  }

  const eventData = {
    screen: Screen.MandatoryEmailVerificationStart,
    target: ClickableElement.SessionsLogOut,
  }

  if (relativeUrl === EMAIL_CODE_VERIFICATION_URL) {
    eventData.screen = screenByEmailCodeView[view]
  }

  track(clickEvent(eventData))
}

export const trackEmailCodeSkipEvent = async ({
  track,
  userId,
}: {
  userId: number
  track: (event: TrackingEvent) => void
}) => {
  const prompts = await fetchCurrentUserVerificationPrompts({ userId })
  if (!prompts) return

  const isEmailCodeMethod = prompts.prompt.methods.includes(VerificationMethods.EmailCode)
  const isMandatory = prompts.prompt.mandatory

  if (!isEmailCodeMethod || isMandatory) return

  track(
    clickEvent({
      screen: Screen.MandatoryEmailVerificationStart,
      target: ClickableElement.Skip,
    }),
  )
}
